/* Home page loading animation */
(function() {
  'use strict';
  var overlay = document.getElementById('loading-overlay');
  if (!overlay) return;
  setTimeout(function() {
    overlay.classList.add('fade-out');
  }, 2400);
  setTimeout(function() {
    overlay.remove();
  }, 2900);
})();
